import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, takeWhile, timer } from 'rxjs';
import { map, shareReplay, startWith } from 'rxjs/operators';
import { BaseViewModel } from '../../../../models/base/base-view-model';

@Injectable()
export class AppOutOfDateModalViewModel extends BaseViewModel {
  constructor() {
    super();
    this.nSecondsTillReload$.subscribeWhileAlive({
      owner: this,
      next: n => {
        if (n <= 0) this.refreshPage();
      }
    });
  }

  private readonly _desc = new BehaviorSubject<string>('');
  public readonly desc$ = this._desc as Observable<string>;
  connectToDesc = (desc: string) => this._desc.next(desc);

  private readonly nSecondTillAutoReload = 90;

  public readonly nSecondsTillReload$ = timer(0, 1000).pipe(
    map(n => this.nSecondTillAutoReload - n),
    takeWhile(n => n >= 0),
    startWith(this.nSecondTillAutoReload),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  public readonly timeUnits$ = this.nSecondsTillReload$.pipe(
    map(nSeconds => {
      return nSeconds > 1 ? 'seconds' : 'second';
    })
  );

  refreshPage(): void {
    window.location.reload();
  }
}
